import * as i0 from '@angular/core';
import { input, output, computed, Component, ViewChild } from '@angular/core';
import { NgxIcon } from '@digipay/ngx-icon';
import * as i1 from '@digipay/ngx-spinner';
import { NgxSpinnerModule } from '@digipay/ngx-spinner';
import { NgxCountDownComponent } from '@digipay/ngx-count-down';
const _c0 = ["button"];
const _c1 = ["*"];
function NgxButtonComponent_Conditional_2_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "ngx-spinner", 2);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("size", ctx_r1.sizeToSpinnerSizeMap[ctx_r1.size()])("color", ctx_r1.brandButton() ? "white" : ctx_r1.styleToSpinnerColorMap[ctx_r1.style()]);
  }
}
function NgxButtonComponent_Conditional_2_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "ngx-spinner", 2);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("size", ctx_r1.sizeToSpinnerSizeMapIconOnly[ctx_r1.size()])("color", ctx_r1.brandButton() ? "white" : ctx_r1.styleToSpinnerColorMap[ctx_r1.style()]);
  }
}
function NgxButtonComponent_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, NgxButtonComponent_Conditional_2_Conditional_0_Template, 1, 2, "ngx-spinner", 2)(1, NgxButtonComponent_Conditional_2_Conditional_1_Template, 1, 2);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵconditional(0, ctx_r1.mode() !== "icon-only" ? 0 : 1);
  }
}
function NgxButtonComponent_Conditional_3_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "ngx-icon", 3);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("iconSize", ctx_r1.sizeToIconSizeMap[ctx_r1.size()])("type", ctx_r1.rightIcon().type || "linear")("name", ctx_r1.rightIcon().name)("secondaryColor", ctx_r1.rightIcon().secondaryColor);
  }
}
function NgxButtonComponent_Conditional_3_Conditional_1_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ngx-count-down", 6);
    i0.ɵɵlistener("finished", function NgxButtonComponent_Conditional_3_Conditional_1_Conditional_2_Template_ngx_count_down_finished_0_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.onFinish());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("timeInSeconds", ctx_r1.timer().timeInSeconds)("type", ctx_r1.timer().timerType);
  }
}
function NgxButtonComponent_Conditional_3_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 4);
    i0.ɵɵprojection(1);
    i0.ɵɵtemplate(2, NgxButtonComponent_Conditional_3_Conditional_1_Conditional_2_Template, 1, 2, "ngx-count-down", 5);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(2, !ctx_r1.isObjectEmpty(ctx_r1.timer()) ? 2 : -1);
  }
}
function NgxButtonComponent_Conditional_3_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "ngx-icon", 3);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("iconSize", ctx_r1.sizeToIconSizeMap[ctx_r1.size()])("type", ctx_r1.leftIcon().type || "linear")("name", ctx_r1.leftIcon().name)("secondaryColor", ctx_r1.leftIcon().secondaryColor);
  }
}
function NgxButtonComponent_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, NgxButtonComponent_Conditional_3_Conditional_0_Template, 1, 4, "ngx-icon", 3)(1, NgxButtonComponent_Conditional_3_Conditional_1_Template, 3, 1, "div", 4)(2, NgxButtonComponent_Conditional_3_Conditional_2_Template, 1, 4, "ngx-icon", 3);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵconditional(0, ctx_r1.rightIcon() ? 0 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(1, ctx_r1.mode() !== "icon-only" ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(2, ctx_r1.leftIcon() ? 2 : -1);
  }
}
const _c2 = () => ["elevation-sticky"];
let NgxButtonComponent = /*#__PURE__*/(() => {
  class NgxButtonComponent {
    constructor(renderer) {
      this.renderer = renderer;
      this.fullWidth = input(false);
      this.mode = input('form');
      this.size = input('large');
      this.style = input('fill');
      this.brandButton = input(false);
      this.destructive = input(false);
      this.rightIcon = input(null);
      this.leftIcon = input(null);
      this.disabled = input(false);
      this.isLoading = input(false);
      this.classNames = input([]);
      this.buttonId = input();
      this.timer = input();
      this.clickHandler = output();
      this.finished = output();
      this.sizeToTypographyClassMap = {
        large: 'bt-1',
        medium: 'bt-2',
        small: 'bt-2',
        tiny: 'bt-3'
      };
      this.sizeToIconSizeMap = {
        large: '24px',
        medium: '24px',
        small: '20px',
        tiny: '16px'
      };
      this.sizeToSpinnerSizeMap = {
        large: 'xl',
        medium: 'lg',
        small: 'md',
        tiny: 'sm'
      };
      this.sizeToSpinnerSizeMapIconOnly = {
        large: 'lg',
        medium: 'lg',
        small: 'md',
        tiny: 'sm'
      };
      this.styleToSpinnerColorMap = {
        fill: 'white',
        'tinted-on-back': 'primary',
        'tinted-on-elevated': 'primary',
        link: 'primary',
        'neutral-link': 'black'
      };
      this.classes = computed(() => {
        const classArr = [...this.classNames(), 'ngx-button', `mode-${this.mode()}`, `style-${this.style()}`, `size-${this.size()}`, this.sizeToTypographyClassMap[this.size()]];
        if (this.brandButton()) {
          classArr.push('is-brand-button');
        }
        if (this.destructive()) {
          classArr.push('is-destructive');
        }
        if (this.disabled()) {
          classArr.push('is-disabled');
        }
        if (this.isLoading()) {
          classArr.push('is-loading');
        }
        return classArr.join(' ');
      });
    }
    onClick(event) {
      this.createRipple(event);
      this.clickHandler.emit(event);
    }
    createRipple(e) {
      const button = this.buttonRef.nativeElement;
      let ripples = this.renderer.createElement('span');
      ripples.classList.add('ripple');
      const centerX = button.offsetWidth / 2;
      const centerY = button.offsetHeight / 2;
      const dimension = Math.max(button.offsetWidth, button.offsetHeight);
      ripples.style.width = `${dimension}px`;
      ripples.style.height = `${dimension}px`;
      ripples.style.position = 'absolute';
      ripples.style.top = `${centerY - dimension / 2}px`;
      ripples.style.left = `${centerX - dimension / 2}px`;
      this.renderer.appendChild(button, ripples);
      setTimeout(() => {
        button.blur();
        this.renderer.removeChild(button, ripples);
      }, 200);
    }
    isObjectEmpty(obj) {
      if (obj) {
        return Object.keys(obj).length === 0;
      }
      return true;
    }
    onFinish() {
      this.finished.emit();
    }
    static {
      this.ɵfac = function NgxButtonComponent_Factory(t) {
        return new (t || NgxButtonComponent)(i0.ɵɵdirectiveInject(i0.Renderer2));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: NgxButtonComponent,
        selectors: [["ngx-button"]],
        viewQuery: function NgxButtonComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c0, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.buttonRef = _t.first);
          }
        },
        hostVars: 2,
        hostBindings: function NgxButtonComponent_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵclassProp("ngx-button-full-width", ctx.fullWidth() && ctx.mode() !== "icon-only");
          }
        },
        inputs: {
          fullWidth: [i0.ɵɵInputFlags.SignalBased, "fullWidth"],
          mode: [i0.ɵɵInputFlags.SignalBased, "mode"],
          size: [i0.ɵɵInputFlags.SignalBased, "size"],
          style: [i0.ɵɵInputFlags.SignalBased, "style"],
          brandButton: [i0.ɵɵInputFlags.SignalBased, "brandButton"],
          destructive: [i0.ɵɵInputFlags.SignalBased, "destructive"],
          rightIcon: [i0.ɵɵInputFlags.SignalBased, "rightIcon"],
          leftIcon: [i0.ɵɵInputFlags.SignalBased, "leftIcon"],
          disabled: [i0.ɵɵInputFlags.SignalBased, "disabled"],
          isLoading: [i0.ɵɵInputFlags.SignalBased, "isLoading"],
          classNames: [i0.ɵɵInputFlags.SignalBased, "classNames"],
          buttonId: [i0.ɵɵInputFlags.SignalBased, "buttonId"],
          timer: [i0.ɵɵInputFlags.SignalBased, "timer"]
        },
        outputs: {
          clickHandler: "clickHandler",
          finished: "finished"
        },
        standalone: true,
        features: [i0.ɵɵStandaloneFeature],
        ngContentSelectors: _c1,
        decls: 4,
        vars: 5,
        consts: [["button", ""], [3, "click", "disabled"], [3, "size", "color"], [3, "iconSize", "type", "name", "secondaryColor"], [1, "button-label"], [3, "timeInSeconds", "type"], [3, "finished", "timeInSeconds", "type"]],
        template: function NgxButtonComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "button", 1, 0);
            i0.ɵɵlistener("click", function NgxButtonComponent_Template_button_click_0_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onClick($event));
            });
            i0.ɵɵtemplate(2, NgxButtonComponent_Conditional_2_Template, 2, 1)(3, NgxButtonComponent_Conditional_3_Template, 3, 3);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵclassMap(ctx.classes());
            i0.ɵɵproperty("disabled", ctx.disabled());
            i0.ɵɵattribute("id", ctx.buttonId());
            i0.ɵɵadvance(2);
            i0.ɵɵconditional(2, ctx.isLoading() ? 2 : 3);
          }
        },
        dependencies: [NgxIcon, NgxSpinnerModule, i1.NgxSpinnerComponent, NgxCountDownComponent],
        styles: ["[_ngcontent-%COMP%]:root{--shimmer-first-color: #CED2DA;--shimmer-second-color: #F1F3F7;--shimmer-third-color: #CED2DA}[_ngcontent-%COMP%]:root   .inverted[_ngcontent-%COMP%]{--shimmer-first-color: #191C23;--shimmer-second-color: #444851;--shimmer-third-color: #191C23}[_ngcontent-%COMP%]:root   .dark[_ngcontent-%COMP%]{--shimmer-first-color: #191C23;--shimmer-second-color: #444851;--shimmer-third-color: #191C23}[_ngcontent-%COMP%]:root   .dark[_ngcontent-%COMP%]   .inverted[_ngcontent-%COMP%]{--shimmer-first-color: #CED2DA;--shimmer-second-color: #F1F3F7;--shimmer-third-color: #CED2DA}[_ngcontent-%COMP%]:root{--base-font-feature-settings: \"ss01\" on, \"liga\" off, \"clig\" off}.ngx-button-full-width[_nghost-%COMP%]{width:100%}.ngx-button-full-width[_nghost-%COMP%]   button.ngx-button[_ngcontent-%COMP%]{width:100%}@keyframes _ngcontent-%COMP%_rippleEffect{to{transform:scale(2);opacity:0}}button.ngx-button[_ngcontent-%COMP%]{all:unset;direction:rtl;position:relative!important;padding:12px 24px;border-radius:12px;cursor:pointer;text-align:center;line-height:28px;min-width:140px;display:flex;align-items:center;justify-content:center;overflow:hidden;font-family:inherit;box-sizing:border-box}button.ngx-button[_ngcontent-%COMP%]   .button-label[_ngcontent-%COMP%]{padding:2px 8px}button.ngx-button[_ngcontent-%COMP%]   .ripple[_ngcontent-%COMP%]{position:absolute;opacity:.24;border-radius:50%;background-color:#fff;animation:_ngcontent-%COMP%_rippleEffect .6s cubic-bezier(.25,1,.5,1);transform:scale(0)}button.ngx-button[_ngcontent-%COMP%]:after{content:\"\";position:absolute;inset:0;background-color:var(--btn-text-onbrand);opacity:0;transition:opacity .2s}button.ngx-button[_ngcontent-%COMP%]:hover:after{opacity:.24}button.ngx-button[_ngcontent-%COMP%]:focus:after{opacity:.24}button.ngx-button.size-large[_ngcontent-%COMP%]{padding:12px 24px;border-radius:12px;height:56px;min-width:140px}button.ngx-button.size-large[_ngcontent-%COMP%]   .button-label[_ngcontent-%COMP%]{padding:2px 8px}button.ngx-button.size-medium[_ngcontent-%COMP%]{padding:10px 16px;border-radius:12px;height:48px;min-width:120px}button.ngx-button.size-medium[_ngcontent-%COMP%]   .button-label[_ngcontent-%COMP%]{padding:2px 8px}button.ngx-button.size-small[_ngcontent-%COMP%]{padding:4px 12px;border-radius:8px;height:36px;min-width:80px}button.ngx-button.size-small[_ngcontent-%COMP%]   .button-label[_ngcontent-%COMP%]{padding:2px 4px}button.ngx-button.size-tiny[_ngcontent-%COMP%]{padding:0 8px;border-radius:6px;height:24px;min-width:60px}button.ngx-button.size-tiny[_ngcontent-%COMP%]   .button-label[_ngcontent-%COMP%]{padding:2px 4px}button.ngx-button.mode-section[_ngcontent-%COMP%]{border-radius:48px}button.ngx-button.mode-icon-only[_ngcontent-%COMP%]{border-radius:50%;min-width:auto!important;padding:0!important}button.ngx-button.mode-icon-only.size-large[_ngcontent-%COMP%]{width:56px}button.ngx-button.mode-icon-only.size-medium[_ngcontent-%COMP%]{width:48px}button.ngx-button.mode-icon-only.size-small[_ngcontent-%COMP%]{width:36px}button.ngx-button.mode-icon-only.size-tiny[_ngcontent-%COMP%]{width:24px}button.ngx-button.style-fill[_ngcontent-%COMP%]{background:var(--btn-bg-onback-job);color:var(--btn-text-onjob)}button.ngx-button.style-fill[_ngcontent-%COMP%]:focus-visible{outline:2px solid var(--btn-bg-onback-job);outline-offset:2px}button.ngx-button.style-fill.is-destructive[_ngcontent-%COMP%]{background:var(--btn-bg-onelevated-job-secondry);color:var(--text-onback-error)}button.ngx-button.style-fill.is-destructive[_ngcontent-%COMP%]:focus-visible{outline:2px solid var(--border-error);outline-offset:2px}button.ngx-button.style-tinted-on-back[_ngcontent-%COMP%]{background:var(--btn-bg-onelevated-job-secondry);color:var(--btn-text-onjob-secondry)}button.ngx-button.style-tinted-on-back[_ngcontent-%COMP%]:focus-visible{outline:2px solid var(--border-brand);outline-offset:2px}button.ngx-button.style-tinted-on-back.is-destructive[_ngcontent-%COMP%]{background:var(--btn-bg-onelevated-job-secondry);color:var(--text-onback-error)}button.ngx-button.style-tinted-on-back.is-destructive[_ngcontent-%COMP%]:focus-visible{outline:2px solid var(--border-error);outline-offset:2px}button.ngx-button.style-tinted-on-elevated[_ngcontent-%COMP%]{background:var(--btn-bg-onback-job-secondry);color:var(--btn-text-onjob-secondry)}button.ngx-button.style-tinted-on-elevated[_ngcontent-%COMP%]:focus-visible{outline:2px solid var(--border-brand);outline-offset:2px}button.ngx-button.style-tinted-on-elevated.is-destructive[_ngcontent-%COMP%]{background:var(--btn-bg-onelevated-destructive);color:var(--text-onback-error)}button.ngx-button.style-tinted-on-elevated.is-destructive[_ngcontent-%COMP%]:focus-visible{outline:2px solid var(--border-error);outline-offset:2px}button.ngx-button.style-link[_ngcontent-%COMP%]{background:transparent;color:var(--btn-text-link)}button.ngx-button.style-link.is-destructive[_ngcontent-%COMP%]{background:transparent;color:var(--text-onback-error)}button.ngx-button.style-link[_ngcontent-%COMP%]:after{opacity:0!important}button.ngx-button.style-link[_ngcontent-%COMP%]:hover{opacity:.8!important;background:none!important}button.ngx-button.style-neutral-link[_ngcontent-%COMP%]{background:transparent;color:var(--btn-text-neutral-link)}button.ngx-button.style-neutral-link.is-destructive[_ngcontent-%COMP%]{background:transparent;color:var(--text-onback-error)}button.ngx-button.style-neutral-link[_ngcontent-%COMP%]:after{opacity:0!important}button.ngx-button.style-neutral-link[_ngcontent-%COMP%]:hover{opacity:.8!important;background:none!important}button.ngx-button.is-brand-button[_ngcontent-%COMP%]{background:var(--btn-bg-onback-brand);color:var(--btn-text-onbrand)}button.ngx-button.is-brand-button[_ngcontent-%COMP%]:focus-visible{outline:2px solid var(--border-brand);outline-offset:2px}button.ngx-button.is-brand-button.is-destructive[_ngcontent-%COMP%]{background:var(--btn-bg-onelevated-job-secondry);color:var(--text-onback-error)}button.ngx-button.is-brand-button.is-destructive[_ngcontent-%COMP%]:focus-visible{outline:2px solid var(--border-error);outline-offset:2px}button.ngx-button.is-disabled[_ngcontent-%COMP%]{opacity:.3!important;cursor:default}button.ngx-button.is-disabled[_ngcontent-%COMP%]:hover:after{opacity:0!important}button.ngx-button.is-disabled[_ngcontent-%COMP%]:focus:after{opacity:0!important}@media (hover: none){button[_ngcontent-%COMP%]:hover:after{opacity:0!important}}"]
      });
    }
  }
  return NgxButtonComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let NgxFabComponent = /*#__PURE__*/(() => {
  class NgxFabComponent {
    constructor() {
      this.style = input('extended');
      this.icon = input(null);
    }
    static {
      this.ɵfac = function NgxFabComponent_Factory(t) {
        return new (t || NgxFabComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: NgxFabComponent,
        selectors: [["ngx-fab"]],
        inputs: {
          style: [i0.ɵɵInputFlags.SignalBased, "style"],
          icon: [i0.ɵɵInputFlags.SignalBased, "icon"]
        },
        standalone: true,
        features: [i0.ɵɵStandaloneFeature],
        ngContentSelectors: _c1,
        decls: 2,
        vars: 7,
        consts: [["size", "large", 3, "classNames", "rightIcon", "brandButton", "mode"]],
        template: function NgxFabComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "ngx-button", 0);
            i0.ɵɵprojection(1);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵstyleMap("fill");
            i0.ɵɵproperty("classNames", i0.ɵɵpureFunction0(6, _c2))("rightIcon", ctx.icon())("brandButton", true)("mode", ctx.style() === "compact" ? "icon-only" : "section");
          }
        },
        dependencies: [NgxButtonComponent]
      });
    }
  }
  return NgxFabComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * Public API Surface of ngx-button
 */

/**
 * Generated bundle index. Do not edit.
 */

export { NgxButtonComponent, NgxFabComponent };
